//#region src/api/orpc/image/errors.ts
/**
* Error code definitions used by the image contract. Defined as a
* standalone object so we get a single literal that's easy to spot in
* code review and re-use across routes inside the namespace.
*/
const imageCreateErrors = {
	UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	},
	INVALID_ARGUMENT: {
		status: 400,
		message: "Invalid argument"
	},
	NOT_FOUND: {
		status: 404,
		message: "Not found"
	},
	CREATION_FAILED: {
		status: 500,
		message: "Task creation failed"
	}
};
//#endregion
export { imageCreateErrors };
